

function frameBuilder(option) {
  const artwork = document.querySelector("#art-container");
  const selectedOption = option.value.trim();
  artwork.dataset.frame = selectedOption;

  const sizeOption = document.querySelector('input[data-type="size"]:checked')?.dataset.value;

  //console.log("frame: " + selectedOption + " size: " + sizeOption);
}

function updateStyleSwatchUI() {
  document.querySelectorAll('input[data-type="style"]').forEach((input) => {
    const label = input.nextElementSibling;
    if (label?.classList.contains('swatch-block')) {
      label.classList.toggle('active', input.checked);
    }
  });
}

function disableStyleSwatchUI() {
  const selectedFrame = document.querySelector('input[data-type="frame"]:checked');
  const shouldDisable = selectedFrame?.dataset.value === 'option-1-5';

  document.querySelectorAll('input[data-type="style"]').forEach((styleInput) => {
    const label = styleInput.nextElementSibling;

    if (styleInput.dataset.value === 'option-3-1') {
      if (shouldDisable) {
        styleInput.setAttribute('disabled', true);
        styleInput.classList.add('disabled');
        label?.classList.add('disabled');


        if (styleInput.checked) {
          const fallback = document.querySelector('input[data-type="style"]:not([disabled])');
          if (fallback) {
            fallback.checked = true;
            initialBuilder(); 
          }
        }
      } else {
        styleInput.removeAttribute('disabled');
        styleInput.classList.remove('disabled');
        label?.classList.remove('disabled');
      }
    }
  });
}






function initialBuilder() {
  const artwork = document.querySelector("#art-container");
  const frameOption = document.querySelector('input[data-type="frame"]:checked')?.dataset.value;
  const sizeOption = document.querySelector('input[data-type="size"]:checked')?.dataset.value;
  const styleOption = document.querySelector('input[data-type="style"]:checked')?.dataset.value;

  //console.log("frame: " + frameOption + " size: " + sizeOption);

  if (artwork) {
    if (frameOption) artwork.dataset.frame = frameOption;
    if (sizeOption) artwork.dataset.size = sizeOption;
    if (styleOption) artwork.dataset.style = styleOption;
  }

  updateStyleSwatchUI();
  disableStyleSwatchUI();
}

document.addEventListener("DOMContentLoaded", () => {
  initialBuilder();


  document.querySelectorAll('input[data-type="frame"]').forEach((input) => {
    input.addEventListener('change', () => {
      initialBuilder();
      disableStyleSwatchUI();
    });
  });


  document.querySelectorAll('input[data-type="size"]').forEach((input) => {
    input.addEventListener('change', () => {
      initialBuilder();
    });
  });

  document.querySelectorAll('input[data-type="style"]').forEach((input) => {
    input.addEventListener('change', initialBuilder);
  });


  const frameSelect = document.querySelector('select');
  if (frameSelect) {
    frameSelect.addEventListener('change', () => {
      frameBuilder(frameSelect);
    });
  }
});
